module.exports = __webpack_public_path__ + "../resources/images/illustration_search_folder-76f1ca4193ebcfc5dde26d975cc2946b.svg";